import { IIamSettings } from "./iamSettings";
import { IamCredentialsActions } from "../../store/iamCredentials/actions";
import { DriveStore } from "../../store/reducers";
import * as logger from "../logger";

export class IamStore implements Storage {

    length: number;

    constructor(private readonly store: DriveStore, private readonly settings: IIamSettings) {
        this.length = 0;
    }

    // according to oidc-client-ts WebStorageStateStore object, clear is not used
    // we also never want to fully clear the redux store on any user logout as there could be other driver(s)
    // https://github.com/authts/oidc-client-ts/blob/main/src/WebStorageStateStore.ts
    clear(): void {
        throw new Error("Method not implemented.");
    }

    getItem(key: string): string | null {
        let iamUserCredentials = this.store.getState().iamCredentials[key];
        if (iamUserCredentials) {
            return iamUserCredentials.user;
        }
        return null;
    }

    // order of the keys is not guaranteed until ES6
    key(index: number): string | null {
        return Object.keys(this.store.getState().iamCredentials)[index];
    }

    removeItem(key: string): void {
        this.length--;
        this.store.dispatch(IamCredentialsActions.removeUser(key));
    }

    setItem(key: string, value: string): void {
        this.length++;
        let tokenEnding = "";
        try {
            let parsedValue = JSON.parse(value);
            tokenEnding = parsedValue.refresh_token ? parsedValue.refresh_token.slice(-5) : "";
        } catch (e) {
            // If parsing fails, do nothing
        }
        logger.log(logger.Source.IAM, `iamStore.setItem: Setting user ${ key } ending with ${ tokenEnding }`);
        this.store.dispatch(IamCredentialsActions.setUser({ userName: key, user: value, iamSettings: this.settings }));
    }
}
